import React from 'react';
import { FormField, NumberInput, InputAdornment } from '@cian/ui-kit';

import { getFieldPlaceholder } from '../../utils/getFieldPlaceholder';
import { IField } from '../../types/calculator';
import { useBaseField } from '../BaseField';

export const InputNumberField: React.FC<IField> = props => {
  const { field, fieldState } = useBaseField(props);

  const isError = fieldState.isDirty || fieldState.invalid;

  const handleChange = (value: number | undefined) => {
    field.onChange(value ? value : undefined);
  };

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <NumberInput
        data-testid={field.name}
        decimalDigits={props.decimalDigits || 0}
        value={Number(field.value)}
        onChange={handleChange}
        placeholder={getFieldPlaceholder(props.placeholder)}
        invalid={Boolean(fieldState.isDirty && fieldState.error)}
        disabled={props.disabled}
        name={field.name}
        ref={field.ref}
        size="M"
        rightAdornment={<InputAdornment>{props.rightAdornment}</InputAdornment>}
        min={0}
      />
    </FormField>
  );
};

InputNumberField.displayName = 'InputNumberField';
